'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M736 0h-448l-288 288v448l288 288h448l288-288v-448l-288-288zM800 704l-96 96-192-192-192 192-96-96 192-192-192-192 96-96 192 192 192-192 96 96-192 192 192 192z' })
    ));
};